/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Box } from "@mui/material";
import LegalbirdLoader from "@/src/components/ContentLoader/LegalbirdLoader";
import ProductBox from "@/src/components/ProductBox/ProductBox";
import React from "react";

export default function MessageFormLoader() {
  return (
    <ProductBox>
      <Box sx={{ padding: "1rem" }}>
        <LegalbirdLoader />
      </Box>
    </ProductBox>
  );
}
